export const GET_AVAILABLE_WIDGETS_FETCH_START =
  "GET_AVAILABLE_WIDGETS_FETCH_START";
export const GET_AVAILABLE_WIDGETS_FETCH_SUCCESS =
  "GET_AVAILABLE_WIDGETS_FETCH_SUCCESS";
export const GET_AVAILABLE_WIDGETS_FETCH_ERROR =
  "GET_AVAILABLE_WIDGETS_FETCH_ERROR";

const initialState = {};

/**
 *
 * @param state - {widgets:[{widgetDefinition}]}
 * @param action
 * @returns {{}}
 */
export const availableWidgetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AVAILABLE_WIDGETS_FETCH_START:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case GET_AVAILABLE_WIDGETS_FETCH_SUCCESS:
      return {
        widgetDefinitions: action.payload,
        error: null,
        loading: false,
      };
    case GET_AVAILABLE_WIDGETS_FETCH_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/mySCC/common/reducers/AvailableWidgetsReducer.js